export { default } from './GlobalityLabelCDS';
